import React from "react";

export default function Contact() {
  return (
    <>
      <nav className="breadcrumbs">Accueil / Contact</nav>
      <h1>Contact</h1>
      <div className="card">
        <p className="color-product-desc">
          Pour toute demande commerciale ou information produit :
        </p>
        <p className="color-product-desc">
          Email :{" "}
          <a href="mailto:contact@thetresorsafe.com">
            contact@thetresorsafe.com
          </a>
          <br />
          Tél. : <a href="tel:+33123456789">+33 1 23 45 67 89</a>
        </p>
        <p className="color-product-desc">Horaires : Lun–Ven, 9h–18h (CET)</p>
      </div>
    </>
  );
}
